<template>
  <pagefra>
    <div class="proprietor container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('业主')">
              <el-input
                v-model="form.ownerName"
                :placeholder="$l('业主')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('手机号码')">
              <el-input
                v-model="form.telNum"
                :placeholder="$l('手机号码')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              @click="showAdd"
              v-if="hasPermission('新增')"
              >{{ $l("新增") }}
            </el-button>
            <el-button
              type="success"
              icon="el-icon-unlock"
              round
              @click="receiveSms(1)"
              v-if="hasPermission('启用')"
              >{{ $l("启用") }}
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-lock"
              round
              @click="receiveSms(0)"
              v-if="hasPermission('禁用')"
            >
              {{ $l("禁用") }}
            </el-button>
            <!-- <el-button icon="el-icon-refresh-right" round>重置</el-button> -->
            <el-button
              icon="el-icon-delete"
              round
              @click="deleteOwner"
              v-if="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" min-width="55"></el-table-column>
            <el-table-column
              :label="$l('序号')"
              type="index"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('业主')"
              prop="ownerName"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('手机')"
              prop="telNum"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              min-width="120"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('大楼名称')"
              prop="buildingName"
              align="center"
              min-width="120"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('房号')"
              prop="roomNum"
              align="center"
              min-width="120"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('电梯')"
              prop="jobNumStr"
              align="center"
              min-width="120"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('接收短信')"
              prop="received"
              align="center"
              min-width="120"
              sortable
            >
              <template slot-scope="scope">
                <!-- <el-switch
                  v-model="scope.row.received == 0"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>-->
                <span v-if="scope.row.received == 1">{{ $l("启用") }} </span>
                <span v-else>{{ $l("禁用") }} </span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('创建时间')"
              prop="createDate"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('编辑')"
              min-width="80"
              show-overflow-tooltip
              header-align="center"
              align="center"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.creator == $store.state.user.username"
                  @click.native.prevent="showEdit(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        :title="$l(editDialogTitle)"
        :visible.sync="editDialogVisible"
        @closed="closeEditDialog"
      >
        <el-form
          ref="editForm"
          :model="editForm"
          :rules="editFormRules"
          label-width="140px"
          size="medium"
          class="dialog-form"
        >
          <el-form-item :label="$l('业主名称')" prop="ownerName">
            <el-input v-model="editForm.ownerName"></el-input>
          </el-form-item>
          <el-form-item :label="$l('手机号码')" prop="telNum">
            <el-input v-model="editForm.telNum"></el-input>
          </el-form-item>
          <el-form-item :label="$l('地盘名称')" prop="domainName">
            <el-input v-model="editForm.domainName"></el-input>
          </el-form-item>
          <el-form-item :label="$l('大楼名称')" prop="buildingName">
            <el-input v-model="editForm.buildingName"></el-input>
          </el-form-item>
          <el-form-item :label="$l('房间号')" prop="roomNum">
            <el-input v-model="editForm.roomNum"></el-input>
          </el-form-item>
          <el-form-item :label="$l('电梯')">
            <el-select
              v-model="editForm.jobNumList"
              multiple
              collapse-tags
              :placeholder="$l('请选择')"
            >
              <el-option
                v-for="item in elevatorList"
                :key="item.id"
                :label="$l(item.name)"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="editDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submit"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import global from "@/mixins/global.js";
export default {
  name: "proprietor",
  mixins: [global],
  components: {
    panel,
    breadcrumb,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateOwnerName = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入业主名称")));
      } else {
        callback();
      }
    };
    var validateTelNum = (rule, value, callback) => {
      if (
        isNaN(value) ||
        value.trim().length != 11 ||
        value.indexOf(".") >= 0
      ) {
        callback(new Error(this.$l("请输入11位数字的手机号")));
      } else {
        callback();
      }
    };
    return {
      date: "",
      form: {
        domainName: "",
        ownerName: "",
        telNum: "",
      },
      isShowButton: false,
      tableData: [],
      loading: false,
      editDialogVisible: false,
      editDialogTitle: "",
      editForm: {
        ownerId: "",
        ownerName: "",
        telNum: "",
        oldTelNum: "",
        domainName: "",
        buildingName: "",
        roomNum: "",
        jobNumList: [],
      },
      editFormRules: {
        ownerName: [
          { validator: validateOwnerName, trigger: "blur" },
          {
            max: 30,
            message: this.$l("长度不能超过 30 个字符"),
            trigger: "blur",
          },
        ],
        telNum: [{ validator: validateTelNum, trigger: "blur" }],
        domainName: [
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
        ],
        buildingName: [
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        roomNum: [
          {
            max: 20,
            message: this.$l("长度不能超过 20 个字符"),
            trigger: "blur",
          },
        ],
      },
      selectedList: [],
      elevatorList: [],
    };
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_owner_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    showAdd() {
      this.editDialogTitle = "新建业主";
      this.editDialogVisible = true;
      this.editForm.ownerId = "";
      this.loadElevatorData();
    },
    showEdit(row) {
      this.editDialogTitle = "编辑业主";
      this.editDialogVisible = true;
      this.loadElevatorData();
      this.$http
        .get(this.$apiConfig.get_owner_url + row.ownerId)
        .then((response) => {
          let data = response.data;
          if (data.code == 0) {
            for (let key in this.editForm) {
              this.editForm[key] = data.data[key];
            }
            this.editForm.oldTelNum = this.editForm.telNum;
          } else {
            this.message(data.code, data.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    loadElevatorData() {
      this.elevatorList = [];
      this.$http
        .get(this.$apiConfig.get_owner_elevators_url)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.elevatorList = result.data;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (this.editForm.jobNumList.length == 0) {
            this.message(1, "请选择电梯");
            return;
          }
          this.$http
            .post(this.$apiConfig.save_owner_url, this.editForm)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.editDialogVisible = false;
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteOwner() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].ownerId);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        this.$http
          .post(this.$apiConfig.delete_owner_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(this.messageType.delete);
            this.$sentry.captureException(error);
          });
      });
    },
    receiveSms(isReceive) {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].ownerId);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        formData.append("isReceive", isReceive);
        this.$http
          .post(this.$apiConfig.set_owner_received_sms_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(this.messageType.operate);
            this.$sentry.captureException(error);
          });
      }, "你确定要" + (isReceive == 1 ? "启用" : "禁用") + "吗？");
    },
    closeEditDialog() {},
  },
  mounted() {
    if (this.loaded) {
      //判断是否为地盘，长度为5的是地盘
      // let areaCode = this.$store.state.user.areaCode;
      // if (areaCode) {
      //   this.isShowButton = areaCode.split(",").length == 5;
      // }
      this.initData();
    }
  },
};
</script>
<style lang="scss" scoped>
.proprietor {
  .el-radio-group {
  }

  /deep/ .el-radio-button__inner {
    padding: 0px 15px;
    margin: 9px 0;
    border-top: 0;
    border-bottom: 0;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border-color: $--border-color-base;
    box-shadow: none;
    background-color: transparent;
    color: $--color-primary;
  }
  /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-left: 0;
  }
  /deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-right: 0;
  }

  .dialog-form {
    .el-input {
      width: 400px;
    }
    .el-select {
      width: 400px;
    }
  }
}
</style>
